import React from 'react';
import { SelectableFilters, truncateAppliedFilters } from './SelectableFilters';
import { FilterComponentProps } from './types';

export type YesNoUnknownOption = 'Yes' | 'No' | 'Unknown';

type YesNoUnknownFilterValues = Record<YesNoUnknownOption, boolean>;

const defaultFilters: YesNoUnknownFilterValues = { Yes: false, No: false, Unknown: false };

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(value.filter(([, applied]) => applied).map(([label]) => label));
}

export const YesNoUnknownFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<YesNoUnknownOption, YesNoUnknownFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={[
      ['Yes', 'Yes'],
      ['No', 'No'],
      ['Unknown', 'Unknown'],
    ]}
    renderValues={renderValues}
  />
);
